export default{

    ALTER_STATE: (state, data) => {
        state.suggestions[data[0]] = data[1]
    }
}